module.exports = __webpack_public_path__ + "img/student-pic001.66754734.png";